import React from "react";
import "./Footer.css";

export function Footer(props) {
  return (
    <div className={"Footer"}>
      <p>Copyright &copy; 2020 by Viktorya Hakobyan</p>
    </div>
  );
}
